<template>
  <div class="container">
    <div class="columns mb-5">
      <div class="column is-one-third py-0">
        <div class="level items-header info is-mobile m-4" v-if="isMobile">
          <div class="level-item is-justify-content-flex-start">
            <b-button
              v-if="
                isUserAuth && Object.keys(this.searchParameters)?.length > 0
              "
              :class="hasSavedCurrentQuery ? 'is-light is-ghost' : 'is-ghost'"
              :disabled="hasSavedCurrentQuery || !this.facets.length"
              @click="saveSearchQuery()"
              >{{
                hasSavedCurrentQuery
                  ? $t("items.searchSaved")
                  : $t("items.searchSave")
              }}</b-button
            >
          </div>
          <div class="level-item is-justify-content-flex-end">
            <transition name="fade">
              <b-icon
                v-if="isLoading"
                pack="fas"
                icon="sync-alt"
                size="is-small"
                custom-class="fa-spin"
                style="margin-right: 10px;"
              />
            </transition>
            <b-button type="is-primary" class="is-right" @click="openSheet()">{{
              $t("items.editSearch")
            }}</b-button>
          </div>
        </div>
        <vue-bottom-sheet-vue2
          :click-to-close="true"
          :is-full-screen="true"
          :overlay="true"
          :swipe-able="true"
          :background-scrollable="true"
          effect="fx-default"
          :rounded="false"
          ref="sheet"
        >
          <div class="has-text-centered">
            <b-button @click="$refs.sheet.close()" class="" type="is-black">{{
              $t("items.closeFilter")
            }}</b-button>
          </div>

          <div v-if="sheetComp == 'AddSubscription'">
            <AddSubscription />
          </div>
          <div v-else>
            <ItemFilter
              ref="filter"
              v-if="isMobile"
              v-bind:isLoading="isLoading"
              v-bind:facets="facets"
              v-bind:showFacets="showFacets"
              v-bind:isTranslatedFacet="isTranslatedFacet"
              v-bind:mainCategories="mainCategories"
              v-bind:subCategories="subCategories"
              v-bind:isCategoryActive="isCategoryActive"
              v-bind:isSubCategoryActive="isSubCategoryActive"
              v-bind:searchQuery="searchQuery"
              @updateFacets="updateFacets"
              @updateItems="updateItems"
              @selectMainCategory="selectMainCategory"
              @selectSubCategory="selectSubCategory"
              @updateSearchQuery="updateSearchQuery"
              @clearSearch="clearSearch"
              @triggerSearch="triggerSearch"
            >
            </ItemFilter>

            <div class="sheet__footer">
              <div class="button-group has-text-centered">
                <b-button @click="closeSheet" class="m-2" type="is-primary"
                  >{{ $t("items.show") }}
                  <strong>{{ resultsFound | numFormat("0,0") }}</strong>
                  {{ $t("items.hits") }}</b-button
                >
              </div>
            </div>
          </div>
        </vue-bottom-sheet-vue2>

        <div v-if="!isMobile">
          <ItemFilter
            ref="filter"
            v-if="!isMobile"
            v-bind:isLoading="isLoading"
            v-bind:facets="facets"
            v-bind:showFacets="showFacets"
            v-bind:isTranslatedFacet="isTranslatedFacet"
            v-bind:mainCategories="mainCategories"
            v-bind:subCategories="subCategories"
            v-bind:isCategoryActive="isCategoryActive"
            v-bind:isSubCategoryActive="isSubCategoryActive"
            v-bind:searchQuery="searchQuery"
            v-bind:selectedParentFacets="selectedFacets"
            @updateFacets="updateFacets"
            @updateItems="updateItems"
            @selectMainCategory="selectMainCategory"
            @selectSubCategory="selectSubCategory"
            @updateSearchQuery="updateSearchQuery"
            @clearSearch="clearSearch"
            @triggerSearch="triggerSearch"
          >
          </ItemFilter>
        </div>

        <transition name="fade">
          <div
            class="mt-4"
            v-if="!isLoading && isUserAuth && this.facets.length"
          >
            <b-button
              v-if="!isMobile && Object.keys(this.searchParameters)?.length > 0"
              :class="hasSavedCurrentQuery ? 'is-light' : 'is-info'"
              :disabled="hasSavedCurrentQuery"
              @click="saveSearchQuery()"
              expanded
              >{{
                hasSavedCurrentQuery
                  ? $t("items.searchSaved")
                  : $t("items.searchSave")
              }}</b-button
            >
          </div>
        </transition>
      </div>
      <div class="column is-two-thirds py-0">
        <div class="level mt-2">
          <div class="level-left"></div>
          <div class="level-right">
            <p
              class="subtitle is-6"
              v-if="!isLoading && resultsFound !== null && !isMobile"
            >
              <strong>{{ resultsFound | numFormat("0,0") }}</strong>
              {{ $t("items.hits") }}
            </p>

            <b-skeleton
              size="is-medium"
              width="5em"
              :active="isLoading && !isMobile"
            ></b-skeleton>
          </div>
        </div>

        <div class="level is-mobile pr-5">
          <div class="level-left">
            <div class="toggleIcons level-item">
              <b-button
                type="is-white"
                ref="itemListStyle"
                @click="toggleItemListStyle()"
                icon-pack="fas"
                :icon-left="this.itemListStyle === 'ItemBox' ? 'list' : 'th'"
              >
              </b-button>
            </div>
          </div>

          <div class="level-item">
            <div class="buttons">
              <b-button
                ref="rfs"
                v-model="readyForSaleOnly"
                :type="readyForSaleOnly ? 'is-dark' : 'is-white'"
                icon-pack="fas"
                icon-left="check-circle"
                @click="toggleRfs"
              >
                <strong>{{ $t("items.readyForSale") }}</strong>
              </b-button>

              <b-button
                v-if="readyForSaleOnly"
                ref="rfsToday"
                v-model="readyForSaleTodayOnly"
                :type="readyForSaleTodayOnly ? 'is-dark' : 'is-white'"
                icon-pack="fas"
                icon-left="check-circle"
                @click="toggleRfsToday"
              >
                <strong>{{ $t("items.showOnlyForToday") }}</strong>
              </b-button>
            </div>
          </div>
          <div class="level-right">
            <div class="level-item">
              <b-select
                :placeholder="$t('items.chooseOrder')"
                v-model="selectedSortBy"
                class="is-pulled-right"
                :disabled="isLoading"
                @change.native="updateItems(true)"
              >
                <option
                  v-for="option in sortBy"
                  :value="option.value"
                  :key="option.value"
                >
                  {{ $t(`items.order.${option.value}`) }}
                </option>
              </b-select>
            </div>
          </div>
        </div>

        <b-taglist>
          <b-tag
            v-if="selectedMainCategory"
            type="is-info"
            @close="removeFilter('main')"
            closable
          >
            {{ $t(`items.categories.${selectedMainCategory}`) }}</b-tag
          >
          <b-tag
            v-if="selectedSubCategory"
            type="is-info"
            @close="removeFilter('sub')"
            closable
          >
            {{ $t(`items.subCategories.${selectedSubCategory}`) }}</b-tag
          >
          <b-tag
            v-if="searchQuery"
            type="is-info"
            @close="removeFilter('search')"
            closable
          >
            {{ searchQuery }}</b-tag
          >
          <b-tag
            v-for="facet in selectedFacets"
            :key="facet.facetCountValue"
            type="is-info"
            closable
            @close="removeFilter(facet.facet)"
          >
            {{ facet.facetCountValue }}
          </b-tag>
        </b-taglist>

        <div
          ref="compContainer"
          class="columns is-multiline is-gapless is-mobile"
        >
          <component
            :is="itemListStyle"
            v-for="item in items.length || resultsFound == 0 ? items : 30"
            v-bind:item="item.document"
            v-bind:key="item.id"
            v-bind:isLoading="isLoading"
            size="6"
            :columns="itemListStyle == 'ItemBox' ? 2 : 1"
          ></component>

          <span v-if="resultsFound == 0">
            {{ $t("items.noResultsFound") }}
          </span>
          <div
            class="mt-2"
            v-if="
              isUserAuth &&
                selectedMainCategory != '' &&
                showSearchSubscribeButton
            "
          >
            {{ $t("items.doYouWantNotification") }}<br /><br />
            <b-button class="is-info" @click="saveSearchQuery()">{{
              hasSavedCurrentQuery
                ? $t("items.searchSaved")
                : $t("items.searchSave")
            }}</b-button>
          </div>
        </div>

        <b-pagination
          class="mt-5"
          v-if="!isLoading && resultsFound"
          :total="resultsFound"
          v-model="page"
          :per-page="perPage"
          range-before="3"
          range-after="1"
          order="is-centered"
          icon-prev="caret-left"
          icon-next="caret-right"
          aria-next-label="Neste side"
          aria-previous-label="Forrige side"
          aria-page-label="Side"
          aria-current-label="Nåværende side"
          @change="changePage()"
        >
        </b-pagination>
      </div>
    </div>

    <b-button
      icon-pack="fas"
      icon-left="sliders-h"
      @click.native="openSheet()"
      class="is-info filterBtn"
    >
    </b-button>
    <b-button @click.native="scrollToTop" class="is-warning scrollToTop">
      <b-icon icon="arrow-up"></b-icon>
    </b-button>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import helpers from "../../helpers";
import modalMixin from "../../mixins/modal";

import isMobile from "mobile-device-detect";

import ItemList from "../home/widget/List";
import ItemBox from "../home/widget/Box";
import ItemFilter from "./ItemFilter";

import { getPreviousRoute } from "@/router";

import AddSubscription from "./AddSubscription.vue";

export default {
  components: { ItemList, ItemBox, ItemFilter, AddSubscription },
  mixins: [helpers, modalMixin],
  data: function() {
    return {
      isLoading: true,
      isMobile: isMobile.isMobile,
      hasSavedCurrentQuery: false,
      searchQuery: "",
      currentFilter: null,
      page: 1,
      perPage: 30,
      itemListStyle: "ItemBox",
      resultsFound: null,
      mainCategories: [],
      subCategories: [],
      facets: [],
      searchParameters: [],
      filtersDirty: false,
      selectedMainCategory: "",
      selectedSubCategory: "",
      selectedFacets: [],
      selectedSortBy: "itemdesc",
      readyForSaleOnly: false,
      readyForSaleTodayOnly: false,
      items: [],
      sortBy: [
        { title: "Avsluttes snart", value: "rfsasc" },
        { title: "Nyeste først", value: "itemdesc" },
        { title: "Pris lav-høy", value: "priceasc" },
        { title: "Pris høy-lav", value: "pricedesc" },
        { title: "Eldste først", value: "itemasc" }
      ]
    };
  },
  created() {
    if (this.$cookies.get("itemListStyle")) {
      this.itemListStyle = this.$cookies.get("itemListStyle");
    }
  },

  unmounted() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  mounted() {
    //window.addEventListener("scroll", this.handleScroll);

    // open filter options by default on mobile if no filters applied
    /* we dont want this anymore
    if (
      !this.$route.query.q &&
      !this.$route.query.filter_by &&
      isMobile.isMobile
    ) {
      this.openSheet();
    }*/

    if (this.$route.query.q) this.searchQuery = this.$route.query.q;
    if (this.$route.query.filter_by) {
      const filterByParams = this.$route.query.filter_by.split("::");
      window._.each(filterByParams, paramsArray => {
        const params = paramsArray.split(":");
        const key = params[0];
        const value = params[1].split(",");

        if (key == "category") {
          this.selectedMainCategory = value[0];
        } else if (key == "subCategory") {
          this.selectedSubCategory = value[0];
        } else {
          window._.each(value, valueArray => {
            this.selectedFacets.push({
              facet: key,
              facetCountValue: valueArray
            });
          });
        }
      });
    }

    if (this.$route.query.page) this.page = parseInt(this.$route.query.page);

    if (this.$route.query.per_page) this.per_page = this.$route.query.per_page;
    if (this.$route.query.rfs) this.readyForSaleOnly = this.$route.query.rfs;
    if (this.$route.query.rfsToday)
      this.readyForSaleTodayOnly = this.$route.query.rfsToday;
    if (this.$route.query.sortBy)
      this.selectedSortBy = this.$route.query.sortBy;

    setTimeout(() => {
      this.updateItems(false);
    }, 500);
  },

  computed: {
    showSearchSubscribeButton() {
      if (this.filtersDirty) {
        return true;
      }
      const previousRoute = getPreviousRoute();
      return previousRoute?.name !== "MyFilters";
    },
    showFacets: function() {
      return this.selectedMainCategory.length > 0;
    },

    ...mapGetters(["isUserAuth"])
  },

  methods: {
    toggleRfs() {
      this.readyForSaleOnly = !this.readyForSaleOnly;

      this.updateItems(true);
    },
    toggleRfsToday() {
      this.readyForSaleTodayOnly = !this.readyForSaleTodayOnly;

      this.updateItems(true);
    },
    handleScroll() {
      let filterBtn = document.querySelector(".filterBtn");
      let toTop = document.querySelector(".scrollToTop");

      if (filterBtn && toTop) {
        if (
          window.scrollY > 150 &&
          !toTop.className.includes("show-animated")
        ) {
          toTop.classList.add("show-animated");
          filterBtn.classList.add("show-animated");
        } else if (window.scrollY < 150) {
          toTop.classList.remove("show-animated");
          filterBtn.classList.remove("show-animated");
        }
      }
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },

    setSelectedMainCategory(val) {
      this.selectedMainCategory = val;
    },
    setSelectedSubCategory(val) {
      this.selectedSubCategory = val;
    },
    removeFilter(facetToRemove) {
      if (facetToRemove == "main") {
        this.selectedMainCategory = "";
        this.selectedFacets = [];
      } else if (facetToRemove == "sub") {
        this.selectedSubCategory = "";
      } else if (facetToRemove == "search") {
        this.clearSearch();
      } else {
        this.selectedFacets = this.selectedFacets.filter(
          facet => facet.facet !== facetToRemove
        );
      }
      this.updateItems(true);
    },
    updateFacets(arr) {
      this.selectedFacets = arr;
    },
    updateSearchQuery(query) {
      this.searchQuery = query;
    },

    openSheet() {
      this.sheetComp = "ItemFilter";
      this.$refs.sheet.open();
    },
    closeSheet() {
      this.$refs.sheet.close();
    },

    toggleItemListStyle() {
      // made this method in case we would add more views. remember to apply styles to watcher
      if (this.itemListStyle == "ItemList") {
        this.itemListStyle = "ItemBox";
      } else {
        this.itemListStyle = "ItemList";
      }

      // store to cookie
      this.$cookies.set("itemListStyle", this.itemListStyle);
    },
    sortByName: function(list) {
      return window._.orderBy(list, "value", "asc");
    },

    clearSearch() {
      this.searchQuery = "";
      this.updateItems(true);
    },

    triggerSearch(event) {
      event.target.blur();

      // see if query is ID and redirect if result is a one hit
      if (this.validIdLookup(this.searchQuery)) {
        this.$router.push({
          name: "Item",
          params: { item: this.searchQuery }
        });
      } else {
        this.updateItems(true);
      }
    },

    changePage() {
      this.updateItems(true);
      this.scrollToTop();
    },

    isTranslatedFacet(facet) {
      if (facet == "readyForSale") return true;
      return false;
    },
    isCategoryActive(index) {
      if (this.selectedMainCategory == this.mainCategories[index].value) {
        return true;
      } else {
        return false;
      }
    },

    isSubCategoryActive(index) {
      if (
        this.subCategories[index] &&
        this.selectedSubCategory == this.subCategories[index].value
      ) {
        return true;
      } else {
        return false;
      }
    },

    selectSubCategory(index) {
      if (this.selectedSubCategory == this.subCategories[index].value) {
        this.selectedSubCategory = "";
      } else {
        this.selectedSubCategory = this.subCategories[index].value;
      }
      this.selectedFacets = [];
      this.updateItems(true);
    },

    selectMainCategory(index) {
      if (this.selectedMainCategory == this.mainCategories[index].value) {
        this.selectedMainCategory = "";
      } else {
        this.selectedMainCategory = this.mainCategories[index].value;
      }
      this.subCategories = [];
      this.selectedSubCategory = "";
      this.selectedFacets = [];
      this.updateItems(true);
    },

    generateSearchQueryParameters() {
      const searchParameters = {};

      if (this.searchQuery.length > 0) {
        searchParameters.q = this.searchQuery;
      }

      if (this.selectedMainCategory.length > 0) {
        if (!searchParameters.filter_by) searchParameters.filter_by = {};
        searchParameters.filter_by["category"] = this.selectedMainCategory;
      }

      if (this.selectedSubCategory.length > 0) {
        if (!searchParameters.filter_by) searchParameters.filter_by = {};
        searchParameters.filter_by["subCategory"] = this.selectedSubCategory;
      }

      if (this.selectedFacets.length > 0) {
        let groupedResult = window._.groupBy(this.selectedFacets, function(
          item
        ) {
          return item.facet;
        });
        groupedResult = window._.mapValues(groupedResult, function(item) {
          return window._.map(item, function(subItem) {
            return subItem.facetCountValue;
          });
        });

        window._.each(groupedResult, function(value, key) {
          if (!searchParameters.filter_by) searchParameters.filter_by = {};
          searchParameters.filter_by[key] = value;
        });
      }

      if (this.page > 1) {
        searchParameters.page = this.page;
      }

      if (this.perPage != 30) {
        searchParameters.perPage = this.per_page;
      }

      if (this.selectedSortBy != "itemdesc") {
        searchParameters.sortBy = this.selectedSortBy;
      }

      if (this.readyForSaleOnly) {
        searchParameters.readyForSaleOnly = this.readyForSaleOnly;
      }

      if (this.readyForSaleTodayOnly) {
        searchParameters.readyForSaleTodayOnly = this.readyForSaleTodayOnly;
      }

      this.searchParameters = searchParameters;

      return searchParameters;
    },

    updateItems(updateRouter) {
      this.isLoading = true;

      const searchParameters = this.generateSearchQueryParameters();
      const routerParameters = { ...searchParameters };

      if (
        routerParameters.filter_by &&
        Object.keys(routerParameters.filter_by).length
      ) {
        routerParameters.filter_by = window._.reduce(
          routerParameters.filter_by,
          function(result, value, key) {
            return result.length == 0
              ? result.concat(`${key}:${value.toString()}`)
              : result.concat(`::${key}:${value.toString()}`);
          },
          ""
        );
      }

      if (updateRouter) {
        this.filtersDirty = true;
        const q = routerParameters.q
          ? "q=" + encodeURIComponent(routerParameters.q)
          : "";

        const f = routerParameters.filter_by
          ? "filter_by=" + encodeURIComponent(routerParameters.filter_by)
          : "";

        const rfs = routerParameters.readyForSaleOnly ? "rfs=true" : "";
        const rfsToday =
          routerParameters.readyForSaleOnly &&
          routerParameters.readyForSaleTodayOnly
            ? "rfsToday=true"
            : "";

        // reset page if filter is changed
        if (
          this.currentFilter &&
          q + f + rfs + rfsToday !== this.currentFilter
        ) {
          this.page = 1;
          searchParameters.page = 1;
          routerParameters.page = 1;
        }

        this.currentFilter = q + f + rfs + rfsToday;

        const page = routerParameters.page > 1 ? `page=${this.page}` : "";

        const urlParams =
          "?" +
          [q, f, page, rfs, rfsToday].filter(param => param != "").join("&");
        history.pushState({}, null, this.$route.path + urlParams);
      }

      this.$axios
        .get(`${window.apiURL}/items`, {
          params: searchParameters
        })
        .then(response => {
          this.mainCategories = this.sortByName(response.data.categories);
          this.subCategories = this.sortByName(
            response.data.subCategories.counts
          );
          this.facets = response.data.facets;
          this.resultsFound = response.data.found;
          this.items = response.data.items;
          this.isLoading = false;
          this.hasSavedCurrentQuery = false;
        })
        .catch(() => {
          //TODO error handling with err
          this.isLoading = false;
          this.hasSavedCurrentQuery = false;
        });
    },

    saveSearchQuery() {
      const searchParameters = this.generateSearchQueryParameters();

      this.openModal({
        component: AddSubscription,
        props: {
          name: "AddSubscription",
          searchParameters: searchParameters,
          count: this.resultsFound
        },
        events: {
          subscriptionAdded: () => {
            this.hasSavedCurrentQuery = true;
          }
        }
      });
    }
  },

  watch: {
    // if this.readyForSaleOnly is false, set this.readyForSaleTodayOnly to false
    readyForSaleOnly: function(val) {
      if (!val) {
        this.readyForSaleTodayOnly = false;
      }
    },

    itemListStyle: function(val) {
      // apply css to comp container
      if (val == "ItemList") {
        this.$refs.compContainer.className = "";
      } else {
        this.$refs.compContainer.className =
          "columns is-multiline is-gapless is-mobile";
      }
    }
  }
};
</script>

<style lang="scss">
.filterBtn {
  transition: opacity 0.6s ease 0s, transform 0.3s ease 0s;
  visibility: hidden;

  &.show-animated {
    visibility: visible;
    position: fixed;
    bottom: 1.5em;
    right: 0;
    transform: translate3d(-100px, -25px, 0px);
    height: 60px;
    display: block;
    z-index: 10;
  }
}
.scrollToTop {
  z-index: 999;
  background: fade(#333, 50%);
  position: fixed;
  right: 0;
  bottom: 1em;

  border-radius: 5px;
  opacity: 0;

  color: hsl(229deg, 53%, 53%);
  font-size: 24px;
  line-height: 50px;
  text-align: center;

  transform: translate3d(-25px, 50px, 0);
  transition: opacity 0.6s ease, transform 0.3s ease;

  &.show-animated {
    opacity: 1;
    transform: translate3d(-25px, -25px, 0);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* fix for janky dragging */

.filterContainer {
  padding-bottom: 5em;
}

.bottom-sheet {
  &__content {
    /*padding-bottom: 5em;*/
    height: 100% !important;
    touch-action: pan-y !important;

    .modal-content,
    .modal-card {
      margin: 0;
    }
  }

  .sheet__footer {
    position: absolute;
    bottom: 0;
    width: 100%;
    border-top: 1px solid #ededed;

    background: #fff;

    .button {
      width: 90%;
    }
  }
}

@media (prefers-reduced-motion: no-preference) {
  html {
    scroll-behavior: smooth;
  }
}
</style>
